import React, { useState, useEffect, useContext } from "react";
import "../Product_Cart.css";
import "../Shop_Now/Shop_Now.css";
import { Breadcrumb, Button, Form, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "js-cookie";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import classNames from "classnames";
import CoupanModal from "../../Common_modal/coupon_modal/couponModal";
import CouponModal from "../../Common_modal/CouponModal/CouponModal";

import { Context } from "../../../utils/context";

import {
  CartCalculation,
  CartQuantity,
  getCart,
  getUnifiedCart,
} from "../../../utils/apis/addToCart/addToCart";

import { getCouponCode } from "../../../utils/apis/orderProcess/orderProcess";
import { Errors } from "../../../utils/errors";
import { useLocation } from "react-use";
import Red_Outline_Btn from "../../Common-Component/common_btn/red_outline_btn/Red_Outline_Btn";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";
import Product_Info_Card from "../../Common-Component/product_info_card/Product_Info_Card";
import Product_Info_Card_3 from "../../Common-Component/product_info_card_3/Product_Info_Card_3";
import Special_Instructions_Modal from "../../Common-Component/Special_Instructions_Modal/Special_Instructions_Modal";
import Blue_Btn from "../../Common-Component/common_btn/blue_btn/Blue_Btn";
import Confirm_Delivery_Address_Offcanvas from "../../Common-Component/confirm_delivery_address_offcanvas/Confirm_Delivery_Address_Offcanvas";
import AddOnModal from "../../Common_modal/addOnModal/AddOnModal";
import { UserGet } from "../../../utils/apis/myAccount/myAccount";
import Login_Modal from "../../Common_modal/login_modal/Login_Modal";
import { Products } from "../../../utils/apis/Product/Product";
import { encodeId } from "../../../utils/common";

const Cart = ({
  setNote,
  note,
  type,
  amount,
  setAmount,
  discount,
  setDiscount,
  coupon,
  setCoupon,
  setTotalTax,
  tax,
}) => {
  const navigate = useNavigate();
  const {
    IMG_URL,
    signin,
    triggerCartUpdate,
    setTaxRupees,
    taxRupees,
    userdata,
  } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const location = useLocation();
  const showButton = location.pathname == "/product-cart-details";
  const [showAddonModal, setShowAddonModal] = useState(false);
  var [totalPrice, setTotalPrice] = useState(0);
  var [totalTax, setTotalTax] = useState(0);
  const [cartSummary, setcartSummary] = useState(0); // Only for guest

  var [totalDeliveryCharge, setTotalDeliveryCharge] = useState(0);
  var [grandTotal, setGrandTotal] = useState(0);
  var [message, setMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [couponStatus, setCouponStatus] = useState(false);

  const [user, setUser] = useState("");
  const onSubmit = async (data) => {
    setError("code", "");
    const res = await getCouponCode(data?.code, amount);

    if (res?.success) {
      if (res?.couponCode) {
        setModalShow(true);
        setCoupon(res?.couponCode?.id);
        setCouponStatus(true);

        if (res?.couponCode?.type === "percentage") {
          setDiscount(
            (Number(totalPrice) * Number(res?.couponCode?.discount)) / 100,
          );
          setMessage(`${res?.couponCode?.discount} % Discount Applied`);
        } else {
          setDiscount(res?.couponCode?.total_amount);
          setMessage(`Coupen Applied of Rs. ${res?.couponCode?.total_amount}`);
        }
        setTimeout(() => {
          setModalShow(false);
          setMessage("");
        }, 3000);
      } else {
        setDiscount(0);
        setCoupon("");
        setCouponStatus(false);
        setError("code", { message: "Coupen Invalid" });
      }
    } else {
      setDiscount(0);
      setCoupon("");
      setCouponStatus(false);
      setError("code", {
        message:
          res?.message || "This coupon has been fully used,Try another Coupon",
      });
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const [cart, setCart] = useState([]);

  const getCartQuantity = async (id, type) => {
    setDiscount(0);
    setCoupon();
    setCouponStatus(false);
    setError("code", "");

    await CartQuantity(id, type);

    if (Cookies.get("local_mandai_cart")) {
      if (JSON.parse(Cookies.get("local_mandai_cart")).length === 0) {
        navigate("/shop-now");
      }
      setCart(JSON.parse(Cookies.get("local_mandai_cart")));
      withoutCart();
      OrderCalculation();
    }
    if (signin) {
      await cartGet();
      if (user) {
        OrderCalculation(user);
      }
    }

    triggerCartUpdate();
  };

  const cartGet = async () => {
    const res = await getCart();
    if (res?.success) {
      if (res?.data.length === 0) {
        navigate("/shop-now");
      }
      setCart(res?.data);
    }
  };

  const GetUser = async () => {
    const res = await UserGet();
    if (res?.success) {
      setUser(res?.data);
    }
  };

  const withoutCart = async () => {
    if (Cookies.get("local_mandai_cart")) {
      const res = await getUnifiedCart();
      if (res?.success) {
        if (res?.data.length === 0) {
          navigate("/shop-now");
        }
        setCart(res?.data?.data);
      }
    }
  };

  useEffect(() => {
    if (signin) {
      cartGet();
    } else {
      withoutCart();
    }
  }, [Cookies.get("local_mandai_cart"), signin]);

  const handleNavigate = async (product_id) => {
    localStorage.setItem("product_id", product_id);
    navigate(`/vendor-page/${encodeId(product_id)}`);
  };

  useEffect(() => {
    getCartQuantity();
  }, []);

  const { currentLocation } = useContext(Context);
  const [products, setProduct] = useState([]);
  const getProducts = async () => {
    const city =
      currentLocation?.formatted_address ||
      currentLocation?.city ||
      currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";

    const res = await Products(
      cart[0]?.product?.category_id,
      "",
      "",
      "",
      "",
      "",
      city,
    );
    if (res?.success) {
      setProduct(res?.data?.data);
    }
  };

  useEffect(() => {
    getProducts();
  }, [cart]);

  const OrderCalculation = async (user) => {
    const res = await CartCalculation(user?.id);
    if (res?.success) {
      setcartSummary(res?.data);
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  useEffect(() => {
    OrderCalculation(user);
  }, [user]);

  const [modalLShow, setModalLShow] = useState(false);
  return (
    <>
      {cart.length > 0 ? (
        <>
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-12">
              <div className="left_side_div">
                <div className="product_table">
                  {cart?.map((value, index) => {
                    const price = Number(value?.product_variant?.s_price || 0);
                    const qty = Number(value?.quantity || 1);
                    const taxPercent = Number(
                      value?.product?.product_detail?.tax_percentage?.name || 0,
                    );
                    const deliveryCharge = Number(
                      value?.product?.delivery_charges || 0,
                    );

                    const baseTotal = price * qty;
                    const taxAmount = (taxPercent * baseTotal) / 100;

                    // Addon total calculation
                    const addOnTotal =
                      value?.cart_addOns?.reduce(
                        (sum, a) => sum + Number(a?.product_addOn?.price || 0),
                        0,
                      ) || 0;

                    const finalTotal =
                      baseTotal + taxAmount + addOnTotal + deliveryCharge;

                    // Add totals to parent variables
                    totalPrice += baseTotal;
                    totalTax += taxAmount;
                    totalDeliveryCharge += deliveryCharge;

                    return (
                      <div className="row tabless mb-4" key={index}>
                        {/* PRODUCT IMAGE */}
                        <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-3 col-4">
                          <div
                            className="cabbageimg"
                            onClick={() => handleNavigate(value?.product_id)}
                          >
                            <img
                              src={
                                IMG_URL +
                                (value?.product_variant?.product_images?.[0]
                                  ?.image || "")
                              }
                              className="cartimg"
                              alt="Product"
                            />
                          </div>
                        </div>

                        {/* PRODUCT DETAILS */}
                        <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-9 col-sm-9 col-8">
                          <div className="row">
                            {/* PRODUCT NAME */}
                            <div className="col-md-12">
                              <div className="prices">
                                <p className="cabbage">
                                  {value?.product?.name} (
                                  {value?.product_variant?.v_name})
                                </p>
                              </div>
                            </div>

                            {/* PRICE DETAILS */}
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                              <div className="prices">
                                <p className="prce">
                                  Price :{" "}
                                  <span>
                                    ₹
                                    {cartSummary?.product_wise?.length > 0
                                      ? Number(
                                          cartSummary.product_wise[index]
                                            ?.price,
                                        ).toFixed(2)
                                      : 0}
                                  </span>
                                </p>

                                <p className="prce">
                                  GST :
                                  <span>
                                    {" "}
                                    {cartSummary?.product_wise?.length > 0
                                      ? Number(
                                          cartSummary.product_wise[index]
                                            ?.total_tax,
                                        ).toFixed(2)
                                      : 0}
                                  </span>
                                </p>

                                {/* <p className="prce">
                                  Delivery Charges :{" "}
                                  <span>
                                    ₹
                                    {cartSummary?.product_wise?.length > 0
                                      ? Number(
                                          cartSummary.product_wise[index]
                                            ?.total_delivery_charges,
                                        ).toFixed(2)
                                      : 0}
                                  </span>
                                </p> */}

                                <p className="prce">
                                  Offer Discount :{" "}
                                  <span>
                                    ₹
                                    {cartSummary?.product_wise?.length > 0
                                      ? Number(
                                          cartSummary.product_wise[index]
                                            ?.offer_discount,
                                        ).toFixed(2)
                                      : 0}
                                  </span>
                                </p>

                                {/* ADDONS */}
                                {value?.cart_addOns?.map((addon) => (
                                  <p className="prce" key={addon?.add_on_id}>
                                    Add On :
                                    <span>
                                      {addon?.product_addOn?.name} - ₹
                                      {cartSummary?.product_wise?.length > 0
                                        ? Number(
                                            cartSummary.product_wise[index]
                                              ?.total_addon,
                                          ).toFixed(2)
                                        : 0}
                                    </span>
                                  </p>
                                ))}

                                {/* TOTAL PRICE */}
                                <p className="prce">
                                  Total Price:
                                  <span>
                                    {" "}
                                    ₹
                                    {cartSummary?.product_wise?.length > 0
                                      ? Number(
                                          cartSummary.product_wise[index]
                                            ?.total_amount,
                                        ).toFixed(2)
                                      : 0}
                                  </span>
                                </p>
                              </div>
                            </div>

                            {/* QUANTITY BOX */}
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12"></div>

                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                              <div className="prices">
                                <div className="qnty">
                                  <div className="counting">
                                    {location.pathname === "/product-cart" && (
                                      <button
                                        className="count-btn"
                                        type="button"
                                        onClick={async () => {
                                          await getCartQuantity(
                                            value?.id,
                                            "minus",
                                          );
                                          await cartGet();
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-minus"
                                          className="minnusicns"
                                        />
                                      </button>
                                    )}

                                    <p className="prce nombers">
                                      {value?.quantity}
                                    </p>

                                    {location.pathname === "/product-cart" && (
                                      <button
                                        className="count-btn"
                                        type="button"
                                        onClick={async () => {
                                          const availableStock = Number(
                                            value?.product_variant?.unit || 0,
                                          );
                                          const currentQty = Number(
                                            value?.quantity,
                                          );

                                          if (currentQty >= availableStock) {
                                            alert(
                                              `Only ${availableStock} unit(s) available!`,
                                            );
                                            return;
                                          }

                                          await getCartQuantity(
                                            value?.id,
                                            "add",
                                          );
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-plus"
                                          className="plusicns"
                                        />
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <Link to={"/"}>
                  <div className="Continue_Shopping_text">
                    <p>Continue Shopping</p>
                  </div>
                </Link>

                <div className="forgot_div">
                  <p className="forgot_text">Forgot Something?</p>
                  <div className="add_btn_div">
                    <Red_Outline_Btn
                      btn_name="+ Add more items"
                      onClick={() => {
                        navigate("/shop");
                      }}
                    />
                  </div>
                </div>

                <div
                  className="delivery_note_div"
                  onClick={() => setModalShow(true)}
                >
                  <div className="">
                    <p className="delivery_note">Delivery Note (Optional)</p>
                  </div>

                  <div className="">
                    <FontAwesomeIcon icon={faPlus} className="plus_icon" />
                  </div>
                </div>

                <div className="you_may_like_div">
                  <Common_Heading_Holder headingText={"You may also like"} />

                  <div className="main_swiper_div">
                    <Swiper
                      spaceBetween={15}
                      pagination={{
                        dynamicBullets: true,
                        clickable: true,
                      }}
                      modules={[Pagination]}
                      autoplay={{ delay: 300 }}
                      className="common_swiper"
                      breakpoints={{
                        0: {
                          slidesPerView: 1.5,
                          spaceBetween: 5,
                        },
                        380: {
                          slidesPerView: 1.5,
                          spaceBetween: 5,
                        },
                        480: {
                          slidesPerView: 2,
                        },
                        768: {
                          slidesPerView: 3,
                        },
                        768: {
                          slidesPerView: 3,
                        },
                        992: {
                          slidesPerView: 3,
                        },
                        1200: {
                          slidesPerView: 3,
                        },
                        1400: {
                          slidesPerView: 3,
                        },
                      }}
                    >
                      {products?.map((product) => {
                        return (
                          <SwiperSlide>
                            <Product_Info_Card_3 product={product} showQty />
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-8">
              <div className="grand_total_table">
                <div className="orderss">
                  <h3 className="heading">
                    <img
                      src="/assets/Image/cart/icon.png"
                      className="icon_img"
                    />{" "}
                    Payment Summary{" "}
                    <span className="inner_text">(incl GST)</span>
                  </h3>
                </div>
                <Table responsive>
                  <thead>
                    <tr className="top-border">
                      <th>Sub Total</th>
                      <td>
                        ₹{Number(cartSummary?.totals?.total_selling).toFixed(2)}
                      </td>
                    </tr>
                  </thead>

                  <thead>
                    <tr className="top-border">
                      <th>Delivery Charges</th>
                      <td>
                        ₹{" "}
                        {Number(
                          cartSummary?.totals?.total_delivery_charges,
                        ).toFixed(2)}
                      </td>
                    </tr>
                  </thead>
                  <thead>
                    <tr className="top-border">
                      <th>Offer Discount</th>
                      <td>
                        ₹{" "}
                        {Number(cartSummary?.totals?.offer_discount).toFixed(2)}
                      </td>
                    </tr>
                  </thead>

                  <thead>
                    <tr className="top-border">
                      <th>Tax</th>
                      <td>
                        ₹{Number(cartSummary?.totals?.total_tax).toFixed(2)}
                      </td>
                    </tr>
                  </thead>

                  <thead>
                    <tr className="top-border">
                      <th>Total Addon</th>
                      <td>
                        ₹ {Number(cartSummary?.totals?.total_addon).toFixed(2)}
                      </td>
                    </tr>
                  </thead>

                  {type === "checkout" && (
                    <thead>
                      <tr className="Coupon_code_holder top-border">
                        <th className="Coupon_code">
                          <Form>
                            <Form.Control
                              type="text"
                              name="code"
                              placeholder="Enter Code"
                              {...register("code", {
                                required: "Code is required",
                              })}
                              className={classNames("", {
                                "is-invalid": errors?.code,
                                "is-valid": getValues("code"),
                              })}
                              onChange={() => {
                                setDiscount(0);
                                setCoupon("");
                                setCouponStatus(false);
                                setError("code", "");
                              }}
                            />
                          </Form>
                        </th>

                        <td>
                          <div className="button-holder">
                            {couponStatus ? (
                              <Button
                                className="Checkout_btn"
                                type="button"
                                onClick={() => {
                                  setDiscount(0);
                                  setCoupon("");
                                  setCouponStatus(false);
                                  reset();
                                }}
                              >
                                Remove Coupon
                              </Button>
                            ) : (
                              <div>
                                <Button
                                  className="Checkout_btn"
                                  type="button"
                                  onClick={handleSubmit(onSubmit)}
                                >
                                  Apply Coupon
                                </Button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <div>
                          <Button
                            className="Checkout_btn show-coupon-btn"
                            type="button"
                            onClick={handleOpenModal}
                          >
                            Show Coupons
                          </Button>
                          <CoupanModal
                            show={showModal}
                            handleClose={handleCloseModal}
                            setValue={setValue}
                          />
                        </div>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <sup
                            className="text-danger"
                            style={{ fontSize: "1.2em" }}
                          >
                            {errors?.code?.message}
                          </sup>
                        </td>
                      </tr>
                    </thead>
                  )}
                  <CouponModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    message={message}
                  />

                  <thead>
                    <tr className="bottom-border">
                      <th className="bold-text">Total</th>
                      <td className="bold-text">
                        ₹
                        <span>
                          {Number(cartSummary?.totals?.total_amount).toFixed(2)}
                        </span>
                      </td>
                    </tr>
                  </thead>
                </Table>

                {type !== "checkout" && (
                  <div className="checkout_btn_holder text-end mt-3">
                    <Blue_Btn
                      btn_name="Proceed to Checkout"
                      onClick={() => {
                        if (signin) {
                          navigate("/saved-address");
                        } else {
                          setModalLShow(true);
                        }
                      }}
                    />
                  </div>
                )}

                {/* old checkout btn code */}
                {/* {type !== "checkout" && (
                  <div className="button-holder text-end mt-3">
                    <Link to={signin ? "/product-cart-details" : "/login"}>
                      <Button className="procheckout_btn" type="button">
                        Proceed to Checkout
                      </Button>
                    </Link>
                  </div>
                )} */}
              </div>
            </div>
          </div>
          {/* {type !== "checkout" && (
            <div className="row justify-content-center">
              <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6">
                <div className="button-holder text-end">
                  <Link to={signin ? "/product-cart-details" : "/login"}>
                    <Button className="procheckout_btn" type="button">
                      Proceed to Checkout
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          )} */}
        </>
      ) : (
        <section className="Empty_Cart">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-3 col-lg-5 col-md-6 col-sm-7 col-10">
                <div className="shop-now-content">
                  <div className="img-holder">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Cash_On_Delivery_Process/basket.png"
                      }
                      className="basket_img"
                      alt="Empty Cart"
                    />
                  </div>
                  <div className="heading_holder mt-3">
                    <h5>Your cart is Empty</h5>
                    <p>
                      You have no items in your shopping cart. Let's go buy
                      something
                    </p>
                    <div className="main-btn-div">
                      <Link to={"/"}>
                        <button className="back-btn" type="button">
                          Shop Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <Login_Modal
        // key={count}
        show={modalLShow}
        onHide={() => setModalLShow(false)}
      />

      <Confirm_Delivery_Address_Offcanvas
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />

      <Special_Instructions_Modal
        note={note}
        setNote={setNote}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <AddOnModal
        show={showAddonModal}
        handleClose={() => setShowAddonModal(false)}
      />
    </>
  );
};

export default Cart;
